import { isNil, isEmpty, isStr } from '../lang';
import { arrify } from '../lang';
/**
 * 针对 url 的解析/修改操作推荐使用新规范
 * URLSearchParams / URL 对象，低版本兼容可以考虑使用 polyfill:
 * https://www.npmjs.com/package/url-polyfill
 */
/**
 *
 * @param url
 * @param data
 * @example
 *
 * compileUrl('/category/:id',{id:277})
 * => '/category/277'
 *
 * compileUrl('/category/:id?type=:type',{id:277, type: 'movie'})
 * => '/category/277?type=movie'
 */
export var compileUrl = function (url, data) {
    url = url.replace(/(\/|=|\&|\?)\:([\w]+)/g, function (_, prefix, key) {
        return prefix + (isNil(data[key]) ? '' : data[key]);
    });
    return url;
};
/**
 * URL 不支持简写的形式，这里把域名和协议都填上
 * @param url
 */
function normalizeUrl(url) {
    if (!/^\w+:/.test(url)) {
        if (/^\/\//.test(url)) {
            return location.protocol + url;
        }
        else if (/^\/\w+/.test(url)) {
            return location.origin + url;
        }
    }
    return url;
}
/**
 * 从 url 中解析出 query 对象, 如果 key 出现多次只返回第一次
 * @param url
 */
export function getQuery(url) {
    url = normalizeUrl(url);
    var urlObj = new URL(url);
    var query = {};
    urlObj.searchParams.forEach(function (v, k) {
        if (!(k in query)) {
            query[k] = v;
        }
    });
    return query;
}
/**
 * 从 url 中解析出 query 对象, 如果 key 出现多次则返回一个字符串数组
 * @param url
 */
export function getQueryAll(url) {
    url = normalizeUrl(url);
    var urlObj = new URL(url);
    var query = {};
    urlObj.searchParams.forEach(function (v, k) {
        query[k] = query[k] || [];
        query[k].push(v);
    });
    return query;
}
export function setQuery(url, name, value) {
    url = normalizeUrl(url);
    var urlObj = new URL(url);
    if (isStr(name)) {
        if (!isEmpty(value)) {
            urlObj.searchParams.set(name, String(value));
        }
    }
    else {
        for (var _i = 0, _a = Object.keys(name); _i < _a.length; _i++) {
            var key = _a[_i];
            var value_1 = name[key];
            if (!isEmpty(value_1)) {
                urlObj.searchParams.set(key, String(value_1));
            }
        }
    }
    return urlObj.toString();
}
/**
 * 从 url 的 query 中删除一个 key
 * @param url
 * @param name
 * @param value
 */
export function deleteQuery(url, name) {
    url = normalizeUrl(url);
    var urlObj = new URL(url);
    var names = arrify(name);
    for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
        var name_1 = names_1[_i];
        urlObj.searchParams.delete(name_1);
    }
    return urlObj.toString();
}
//# sourceMappingURL=url.js.map